import React from 'react';

function CtaCartIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M12.959 10.8332C13.584 10.8332 14.134 10.4915 14.4173 9.97484L17.4007 4.5665C17.709 4.0165 17.309 3.33317 16.6757 3.33317H4.34232L3.55898 1.6665H0.833984V3.33317H2.50065L5.50065 9.65817L4.37565 11.6915C3.76732 12.8082 4.56732 14.1665 5.83398 14.1665H15.834V12.4998H5.83398L6.75065 10.8332H12.959ZM5.13398 4.99984H15.259L12.959 9.1665H7.10898L5.13398 4.99984ZM5.83398 14.9998C4.91732 14.9998 4.17565 15.7498 4.17565 16.6665C4.17565 17.5832 4.91732 18.3332 5.83398 18.3332C6.75065 18.3332 7.50065 17.5832 7.50065 16.6665C7.50065 15.7498 6.75065 14.9998 5.83398 14.9998ZM14.1673 14.9998C13.2507 14.9998 12.509 15.7498 12.509 16.6665C12.509 17.5832 13.2507 18.3332 14.1673 18.3332C15.084 18.3332 15.834 17.5832 15.834 16.6665C15.834 15.7498 15.084 14.9998 14.1673 14.9998Z'
				fill='white'
			/>
		</svg>
	);
}

export default CtaCartIcon;
